/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Col,
  Form,
  Input,
  Row,
  Space,
  Table,
  DatePicker,
  Select,
  Modal,
  Divider,
  DatePickerProps,
} from 'antd';
import Button from 'components/Button';
import MainLayout from 'components/Modules/Layout/MainLayout';
import useQueryParam from 'hooks/useQueryPrams';
import { IGetUserQuery } from 'interface/user.interface';
import { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import updateQueryStringParameter from 'utils/updateQueryStringParameter';
import {
  AddIcon,
  DeleteIcon,
  DeleteIconGrey,
  EditIcon,
  EyeIcon,
  FilterGoldIcon,
  FilterIcon,
} from 'assets/svg';
import { Content } from 'antd/es/layout/layout';
import PortfolioApi from 'apis/PortfolioApi';
import { IGetPortfolioQuery, IPortfolio } from 'interface/portfolio.interface';
import pageTitleStore from 'store/pageTitleStore';
import moment from 'moment';
import { HocChangePagination } from 'utils/HocChangePagination';
import ApprovalApi from 'apis/ApprovalApi';
import { ColumnsType } from 'antd/es/table';
import PofTypeApi from 'apis/PofTypeApi';
import { IPagination } from 'interface/base.interface';
import { PORTFOLIO_STATUS } from 'constants/portfolioStatus';
import RoleBasedAuth from 'apis/RoleBasedAPI';
import PopupMaMau from 'pages/Cart/Order/MaMauView';
import { useForm } from 'antd/es/form/Form';
import { DeleteOutlined } from '@ant-design/icons';
import { openNotificationWithIcon } from 'utils/notification';

type FixedType = 'left' | 'right' | boolean;

export default function CategoryManagementPage(): JSX.Element {
  const history = useHistory();
  const [form] = useForm();
  const { Option } = Select;

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [deleteCategoryModel, setDeleteCategoryModel] = useState<any>();

  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);

  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;
  const [formSubmitParams, setFormSubmitParams] = useState<any>();
  const [formSubmitDate, setFormSubmitDate] = useState<any>();
  const userParams = {
    page,
    page_size,
    ...(formSubmitParams && formSubmitParams),
  };

  const { RangePicker } = DatePicker;

  const {
    data: lstPortfolio,
    isLoading: getPortfoliosLoading,
    mutate: refetch,
  } = useMutation(['getAll'], () => PortfolioApi.getAll(userParams));

  const { data: lstPofType } = useQuery(['getAll'], () => PofTypeApi.getAll());

  // const { data: lstUsers } = useQuery(['getUsers', getUserParams], () =>
  //   RoleBasedAuth.getUsers(getUserParams)
  // );

  // const handleUpdateUser = (data: any) => {};
  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 60,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã danh mục',
      dataIndex: 'pof_code',
      width: 124,
    },
    {
      title: 'Loại danh mục',
      width: 155,
      dataIndex: 'pof_type_name',
    },
    {
      title: 'Tên danh mục',
      dataIndex: 'pof_name',
      width: 155,
    },
    {
      title: 'Bộ phận phát triển',
      width: 177,
      render: (_: any, record: IPortfolio) => {
        return record?.product_group
          ?.map((group: any) => group.grp_name)
          .join(', ');
      },
    },
    {
      title: 'Người khai báo',
      dataIndex: 'createBy',
      width: 161,
      render: (_: any, record: IPortfolio) => {
        return record?.user_created?.fullName;
      },
    },
    // {
    //   title: 'Phòng ban',
    //   width: 115,
    //   render: (_: any, record: IPortfolio) => {
    //     return record?.user_created?.division;
    //   },
    // },
    {
      title: 'Đơn vị phát hành',
      dataIndex: 'branch',
      width: 180,
      render: (_: any, record: IPortfolio) => {
        return record?.user_created?.departmentName;
      },
    },
    {
      title: 'Công ty phát hành',
      width: 158,
      render: (_: any, record: IPortfolio) => {
        return record?.user_created?.organization;
      },
    },
    {
      title: 'Đặt hàng theo ni',
      width: 158,
      render: (_: any, record: IPortfolio) => {
        return record?.allow_order_ni === true ? 'Có' : 'Không';
      },
    },
    {
      title: 'Trạng thái',
      width: 155,
      render: (_: any, record: IPortfolio) => {
        switch (record?.status) {
          case 0:
            return 'Mới tạo';
          case 1:
            return 'Chờ phê duyệt';
          case 2:
            return 'Đã phát hành';
          case 3:
            return 'Hết hạn';
          default:
            return '-';
        }
      },
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'created_at',
      width: 130,
      render: (_: any, record: IPortfolio) => {
        return moment(record?.created_at).format('DD/MM/YYYY');
      },
    },
    {
      title: 'Ngày hết hạn',
      dataIndex: 'end_date',
      width: 130,
      render: (_: any, record: IPortfolio) => {
        return moment(record?.end_date).format('DD/MM/YYYY');
      },
    },
    {
      title: 'Thao tác',
      fixed: 'right' as FixedType,
      width: 120,
      align: 'center',
      render: (_: any, record: IPortfolio) => (
        <div className="flex justify-around">
          <button
            onClick={() => history.push(`/category/${record.id}`, record)}
          >
            <EyeIcon />
          </button>
          {/* <button
            onClick={() => {
              onGoToEditCategory(record?.id);
            }}
          >
            <EditIcon />
          </button> */}
          <button
            onClick={() => {
              if (record?.status == 0) {
                setDeleteCategoryModel(record);
                setModalOpen(true);
              }
            }}
          >
            {record?.status == 0 ? <DeleteIcon /> : <DeleteIconGrey />}
          </button>
        </div>
      ),
    },
  ];

  const { mutate: deleteCategory, isLoading: isDeleting } = useMutation(
    ['deleteCategory'],
    (id: any) => PofTypeApi.deleteCategory(id),
    {
      onSuccess: (response: any) => {
        refetch();
      },
      onError: (error: any) => {
        openNotificationWithIcon('error', error.message);
      },
    }
  );

  const onChange: DatePickerProps['onChange'] = (date, dateString) => {
    if (date != null) {
      setFormSubmitDate({
        ...formSubmitDate,
        from_date: dateString[0],
        to_date: dateString[1],
      });
    }
  };

  const onFinish = (values: any) => {
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(([_, value]) => value !== undefined)
    );
    const stringifiedData: { [key: string]: any } = {};
    Object.keys(filteredData).forEach((key) => {
      if (key != 'fromToDate') {
        if (key == 'status') {
          if (String(filteredData[key]) != '99')
            stringifiedData[key] = String(filteredData[key]);
        } else if (String(filteredData[key]) != '')
          stringifiedData[key] = String(filteredData[key]);
      }
    });
    const today = formSubmitDate?.to_date.split('/');
    const getToday = moment(today[2] + today[1] + today[0])
      .add(1, 'day')
      .format('DD/MM/YYYY');
    stringifiedData['from_date'] = formSubmitDate?.from_date;
    stringifiedData['to_date'] = getToday;
    setFormSubmitParams(stringifiedData);
  };

  const handleReset = () => {
    form.resetFields();
    setFormSubmitParams(undefined);
  };

  const onGoToAddCategory = () => {
    history.push('/add-category/category-info-step');
  };

  const onGoToEditCategory = (id: number) => {
    history.push(`/add-category/category-info-step/${id}`);
  };

  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };

  useEffect(() => {
    setTitle('Danh mục hàng hóa');
    setBreadcrumb([{ title: <a href="/category">Danh mục hàng hóa</a> }]);
    refetch();
  }, [page, page_size, formSubmitParams]);

  return (
    <MainLayout isLoading={false}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
        <Col span={12} className="flex justify-end">
          <Space>
            <Button onClick={onGoToAddCategory}>
              <AddIcon />
              Tạo mới
            </Button>
            <Button
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
          </Space>
        </Col>
      </Row>

      <Form
        form={form}
        layout="vertical"
        className={` ${isOpenFilter ? '' : 'hidden'} mt-4`}
        onFinish={onFinish}
        autoComplete="off"
        size="small"
      >
        <Content style={{ paddingTop: '10px', paddingBottom: '10px' }}>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={8}>
              <Form.Item
                name="pof_code"
                label="Mã danh mục"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Input
                  placeholder="Nhập mã danh mục"
                  style={{ padding: '9px 16px' }}
                />
              </Form.Item>
            </Col>

            <Col className="" span={8}>
              <Form.Item
                name="pof_name"
                label="Tên danh mục"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Input
                  placeholder="Nhập tên danh mục"
                  style={{ padding: '9px 16px' }}
                />
              </Form.Item>
            </Col>

            <Col className="" span={8}>
              <Form.Item
                name="pof_type_code"
                label="Loại danh mục"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select placeholder="Chọn">
                  <Option value="">Tất cả</Option>
                  {lstPofType?.data?.map((item) => (
                    <Option value={item.pof_type_code} key={item.id}>
                      {item.pof_type_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {/* <Col className="" span={8}>
              <Form.Item name="division_id" label="Phòng ban">
                <Input placeholder="Chọn phòng ban" className="" />
              </Form.Item>
            </Col> */}
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            {/* <Col className="" span={8}>
              <Form.Item name="createBy" label="Người tạo">
                <Select placeholder="Chọn người tạo">
                  {lstUsers?.data?.map((item) => (
                    <Option value={item.email} key={item.id}>
                      {item.fullName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col> */}
            <Col className="" span={8}>
              <Form.Item
                name="created_by"
                label="Người tạo"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Input
                  placeholder="Chọn người tạo"
                  style={{ padding: '9px 16px' }}
                />
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item
                name="fromToDate"
                label="Ngày tạo"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <RangePicker
                  placeholder={['dd/mm/yyyy', 'dd/mm/yyyy']}
                  format={'DD/MM/YYYY'}
                  style={{ padding: '9px 16px' }}
                  onChange={onChange}
                />
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item
                name="status"
                label="Trạng thái danh mục"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select placeholder="Tất cả">
                  {PORTFOLIO_STATUS.map((item) => (
                    <Option
                      value={item.values}
                      key={item.name}
                      defaultValue={null}
                    >
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="end"
            className="mt-1.5"
          >
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={handleReset}
                >
                  Hủy
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>

      <Content className="main-content mt-4">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          className="customTable"
          dataSource={lstPortfolio?.data}
          scroll={{ x: 958 }}
          loading={getPortfoliosLoading || isDeleting}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: lstPortfolio?.total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Content>
      <Modal
        open={modalOpen}
        onCancel={() => {
          setModalOpen(false);
        }}
        footer={null}
        width={'50%'}
      >
        <Content className="w-full">
          <p className="text-2xl font-bold">Xóa danh mục hàng hóa</p>
          <Divider style={{ margin: '20px 0' }} />
          <div>
            <p className="text-base">
              Bạn có chắc muốn xóa danh mục: {deleteCategoryModel?.pof_name} ?
              <br />
            </p>
          </div>
          <Row justify="end" className="mt-4">
            <Button
              onClick={() => {
                setModalOpen(false);
              }}
              customClass="text-neutral-50 mr-2"
              bgColor="white"
            >
              Huỷ
            </Button>
            <Button
              onClick={() => {
                deleteCategory(deleteCategoryModel?.id);
                setModalOpen(false);
              }}
            >
              Xóa danh mục
            </Button>
          </Row>
        </Content>
      </Modal>
    </MainLayout>
  );
}
